import { ManageAccounts, Cancel } from '@mui/icons-material';
import { deepPurple } from '@mui/material/colors';
import { useState } from 'react';
import { Button, Modal, Box, CircularProgress, Typography, Grid, Autocomplete, Select, MenuItem, Checkbox, TextField } from '@mui/material';
import { DatePicker, DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { axiosInstance } from 'utils/axios';
import { selectCurrentToken } from 'features/auth/authSlice';
import { useSelector } from 'react-redux';
import { successAlert } from 'ui-component/Toasts';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const UpdatedriverListRecord = ({ driverList, fetchDriversRecord, driverCarTypeID, driverCurrentStatus }) => {
    const token = useSelector(selectCurrentToken);

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [updateName, setupdateName] = useState(driverList.name ? driverList.name : '');
    const [updatePlateNo, setupdatePlateNo] = useState(driverList.plateNo ? driverList.plateNo : '');
    const [updateRating, setupdateRating] = useState(driverList.rating);
    const [updateCartTypeID, setupdateCartTypeID] = useState(driverList.carTypeID);
    const [updateCurrentStatusID, setupdateCurrentStatusID] = useState(driverList.currentStatusID);
    const [updateStartWorkDate, setupdateStartWorkDate] = useState(dayjs(driverList.startWorkDateTime));
    const [updateEndWorkDate, setupdateEndWorkDate] = useState(dayjs(driverList.endWorkDateTime));
    const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
    const [updatedriverListLoading, setUpdatedriverListLoading] = useState(false);

    const submitInsertTasklist = async () => {
        setUpdateBtnDisabled(true);
        setTimeout(() => {
            setUpdateBtnDisabled(false);
        }, 3000);
        setUpdatedriverListLoading(true);
        try {
            const res = await axiosInstance.put(
                '/Driver',
                {
                    id: driverList.id,
                    name: updateName,
                    plateNo: updatePlateNo,
                    rating: parseFloat(updateRating),
                    carTypeID: parseFloat(updateCartTypeID),
                    currentStatusID: parseFloat(updateCurrentStatusID),
                    startWorkDateTime: updateStartWorkDate.toISOString(),
                    endWorkDateTime: updateEndWorkDate.toISOString(),
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('Driver Updated successfully.');
                fetchDriversRecord();
                setOpen(false);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setUpdatedriverListLoading(false);
        }
    };

    return (
        <>
            <Button
                onClick={handleOpen}
                sx={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    width: 'fit-content',
                    height: 'fit-content',
                    color: deepPurple[500]
                }}
            >
                <ManageAccounts />
            </Button>

            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                {updatedriverListLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box sx={style}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography id="modal-modal-title" variant="h3" component="h2">
                                Update Drivers
                            </Typography>
                            <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                        </Box>
                        <Box
                            id="modal-modal-description"
                            sx={{
                                height: '450px',
                                overflowY: 'auto'
                            }}
                        >
                            <Grid item container xs={12} sx={{ mt: 2 }}>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Name :
                                        </Typography>
                                        <input
                                            type="text"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={updateName}
                                            onChange={(e) => setupdateName(e.target.value)}
                                        />
                                    </Box>
                                </Grid>

                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Plate No :
                                        </Typography>
                                        <input
                                            type="text"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={updatePlateNo}
                                            onChange={(e) => setupdatePlateNo(e.target.value)}
                                        />
                                    </Box>
                                </Grid>

                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Rating :
                                        </Typography>
                                        <input
                                            type="number"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={updateRating}
                                            onChange={(e) => setupdateRating(e.target.value)}
                                        />
                                    </Box>
                                </Grid>

                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Car Type ID :
                                        </Typography>
                                        <Select
                                            displayEmpty
                                            value={updateCartTypeID}
                                            onChange={(e) => setupdateCartTypeID(e.target.value)}
                                            // sx={{width:"100%"}}
                                        >
                                            <MenuItem sx={{ width: '100%' }} value="">
                                                Select Status
                                            </MenuItem>
                                            {driverCarTypeID.map((item, index) => (
                                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Current Status ID :
                                        </Typography>
                                        <Select
                                            displayEmpty
                                            value={updateCurrentStatusID}
                                            onChange={(e) => setupdateCurrentStatusID(e.target.value)}
                                            // sx={{width:"100%"}}
                                        >
                                            <MenuItem sx={{ width: '100%' }} value="">
                                                Select Status
                                            </MenuItem>
                                            {driverCurrentStatus.map((item, index) => (
                                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Box>
                                </Grid>

                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Start Work Date :
                                        </Typography>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateTimePicker
                                                value={updateStartWorkDate}
                                                onChange={(newValue) => setupdateStartWorkDate(newValue)}
                                                renderInput={(props) => <TextField {...props} />}
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            End Work Date :
                                        </Typography>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateTimePicker
                                                value={updateEndWorkDate}
                                                onChange={(newValue) => setupdateEndWorkDate(newValue)}
                                                renderInput={(props) => <TextField {...props} />}
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <Button
                            variant="contained"
                            sx={{
                                display: 'block',
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '50px'
                            }}
                            onClick={() => submitInsertTasklist()}
                            disabled={updateBtnDisabled}
                        >
                            Update
                        </Button>
                    </Box>
                )}
            </Modal>
        </>
    );
};

export default UpdatedriverListRecord;
